import { Component, Input } from '@angular/core';
import { IErrorDescription } from '@ibank-globals/error';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize, take } from 'rxjs/operators';
import { SourceApis } from '../../../globals/classes/errorDescription';
import { ErrorHandler } from '../../../globals/classes/errorHandler';
import { ICreateApplicationRequest } from '../../classes/existing-onboarding-customer/requests';
import {
	GetRegisteredMobileNumbersResponse,
	IGetRegisteredMobileNumbersResponse,
} from '../../classes/existing-onboarding-customer/responses';
import { LoginAction } from '../../classes/static/enums';
import { Extensions } from '../../classes/static/extensions';
import { ExistingOnboardingCustomerService } from '../../services/existing-recovery/customer.service';
import { LoginService } from '../../services/login.service';
import { CardDetailsModalComponent } from '../card-details-modal/card-details-modal.component';
import { ContactInfoModalComponent } from '../contact-info-modal/contact-info-modal.component';
import { BaseComponent } from '../../../globals/classes/base.component';
import { AppSettings } from '../../app.settings';

@Component({
	selector: 'existing-ibank-modal',
	template: require('./existing-ibank-modal.component.html'),
})
export class ExistingIbankModalComponent extends BaseComponent {
	@Input() public isExistingCustomer = false;
	@Input() appRequest: ICreateApplicationRequest;

	public isLoading: boolean = false;
	public isConnectLoading: boolean = false;
	public dynatraceForExistingOnBoarding: boolean = AppSettings.dynatraceForExistingOnBoarding;
	public isRebrading = AppSettings.isRebrading;

	constructor(private activeModal: NgbActiveModal, private modalService: NgbModal) {
		super();
	}

	public toggleCardDetails(): void {
		this.activeModal.close();
		const modalRef = this.modalService.open(CardDetailsModalComponent, {
			windowClass: 'modal-small',
		});
		(modalRef.componentInstance as CardDetailsModalComponent).createApplicationRequest =
			this.appRequest;
		// (modalRef.componentInstance as CardDetailsModalComponent).isExistingCustomer = this.isExistingCustomer;
	}

	public closeModal(): void {
		this.activeModal.close();
	}
	public connectNow(): void {
		if (this.dynatraceForExistingOnBoarding) this._setConnectNowDynatraceEvent();
		this.invokeConnectNow();
	}
	public toggleContactInfo(): void {
		if (this.dynatraceForExistingOnBoarding) this._setForgotCredsDynatraceEvent();
		this.invokeRegisteredMobileNumber();
	}

	private _setForgotCredsDynatraceEvent() {
		this.setDynatraceEvent('ECO_Already_Have_Creds_Forgot_Creds');
	}

	private _setConnectNowDynatraceEvent() {
		this.setDynatraceEvent('ECO_Already_Have_Creds_Connect_Now');
	}

	private invokeConnectNow() {
		this.isConnectLoading = true;
		LoginService.loginAction$
			.pipe(take(1))
			.pipe(finalize(() => (this.isConnectLoading = false)))
			.subscribe((action) =>
				action === LoginAction.RenewLink
					? (window.location.href = Extensions.returnUrl)
					: this.activeModal.close()
			);
	}

	private invokeRegisteredMobileNumber(): void {
		if (!this.appRequest.appId) return;
		this.isLoading = true;
		ExistingOnboardingCustomerService.getRegisteredMobileNumbers(this.appRequest.appId)
			.pipe(finalize(() => (this.isLoading = false)))
			.subscribe(
				(result) => this.handleRegisteredMobileNumberResponse(result),
				(error) => this.handleError(error, SourceApis.Onboarding)
			);
	}
	private handleRegisteredMobileNumberResponse(response: IGetRegisteredMobileNumbersResponse) {
		if (!!response) {
			this.activeModal.close();
			const modalRef = this.modalService.open(ContactInfoModalComponent, {
				windowClass: 'modal-small',
			});
			(
				modalRef.componentInstance as ContactInfoModalComponent
			).getRegisteredMobileNumbersResponse = new GetRegisteredMobileNumbersResponse(response);
			(modalRef.componentInstance as ContactInfoModalComponent).appRequest = this.appRequest;
			(modalRef.componentInstance as ContactInfoModalComponent).isExistingCustomer =
				this.isExistingCustomer;
		}
	}
	private handleError(error: IErrorDescription, sourceApi: SourceApis): void {
		ErrorHandler.newError(error, sourceApi);
	}
}
